import React, { Component } from "react"
import PropTypes from "prop-types"
import { Row, Col, Card, CardBody } from "reactstrap"
import { Link, withRouter  } from "react-router-dom"
import gridView from "../../../../assets/img/grid-view.png"
import engagementView from "../../../../assets/img/engagement-view.png"


class ProjectMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  isActive(path) {
    return this.props.location.pathname === path ? "active" : ""
  }
  render() {
    return (
        <React.Fragment>           
        <Row className="">
          <Col sm="12">
            <div className="">
              <div className="btn-group rl-group-btn" role="group">
                <Link to="/pre-construction/my-project">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/pre-construction/my-project")}`}
                  >
                   <span className="d-flex align-items-center gap-2">
                    Grid View

                     <img src={gridView} style={{height:16}} />
                     </span>
                  </button>
                </Link>
                <Link to="/pre-construction/compare-project">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/pre-construction/compare-project")}`}
                  >
                    
                   <span className="d-flex align-items-center gap-2">
                    Compare Projects

                    <img src={engagementView} style={{height:16}} />
                    </span>
                  </button>
                </Link>
                
              </div>
            </div>     
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}
ProjectMenu.propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired
    }).isRequired
  }
export default withRouter(ProjectMenu)
